import { Switch, Route, Redirect } from "react-router-dom";
import { AuthZeroLoginPage, VerifyEmailPage } from "pages/AuthPages";
import { routes } from "utils/constants/routes";

const UnauthedApp = () => (
  <Switch>
    <Route path={routes.LOGIN} component={AuthZeroLoginPage} />
    <Route path={routes.VERIFY_EMAIL} component={VerifyEmailPage} />
    <Redirect to={routes.LOGIN} />
  </Switch>
);

// eslint-disable-next-line import/no-default-export
export default UnauthedApp;
